import React from 'react';
import { productImages, siteConfig } from '../../data/siteConfig';
import { formatPrice } from '../../utils/currency';
interface OrderLineItemProps {
  quantity: number;
  children?: React.ReactNode;
  compact?: boolean;
}

/** Visual line item used inside the frame placeholders. Native frames render the real line items. */
export function OrderLineItem({
  quantity,
  children,
  compact = false
}: OrderLineItemProps) {
  const {
    product
  } = siteConfig;
  return <div className="flex gap-5" data-id="element-27" data-mp="1vzxbnxluk6l6">
      <div className={`shrink-0 overflow-hidden rounded-[3px] border border-line bg-surface ${compact ? 'h-20 w-20' : 'h-24 w-24 md:h-28 md:w-28'}`} data-id="element-28" data-mp="1r74471yzuk5e">
        <img src={productImages.white.src} alt="" className="h-full w-full scale-[1.06] object-contain" data-id="element-29" data-mp="1m5wzjbs5e12y" />
      </div>
      <div className="flex min-w-0 flex-1 flex-col" data-id="element-30" data-mp="1d7bgzgmoem26">
        <div className="flex items-start justify-between gap-4" data-id="element-31" data-mp="1d6tcxxtrv3jp">
          <div data-id="element-32" data-mp="1888ea2u64rxd">
            <p className={`font-display text-ink ${compact ? 'text-xl' : 'text-2xl'}`} data-id="element-33" data-mp="189t5bih9xsqh">{product.name}</p>
            <p className="mt-0.5 text-[14px] text-ink-muted" data-id="element-34" data-mp="18al26kookh5q">
              {product.descriptor} · {product.color}
              {compact && ` · Qty ${quantity}`}
            </p>
          </div>
          <p className="text-[15px] font-medium tabular-nums text-ink" data-id="element-35" data-mp="zcr4b5b9pfgg">{formatPrice(product.samplePrice * quantity)}</p>
        </div>
        {children && <div className="mt-auto pt-4" data-id="element-36" data-mp="1s056pixqj37y">{children}</div>}
      </div>
    </div>;
}